"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteHours = void 0;
function deleteHours(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, use = utils.use, hasReturnVal = utils.hasReturnVal;
    describe('Hours - Delete', function () {
        it('Should clear hours on delete key press', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .then(use.del)
                .should('have.value', '--:30 PM')
                .then(a11yHasExpectedHtml("<p>blank.</p>"))
                .then(hasReturnVal(''));
        });
        it('Should clear hours on backspace key press', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .then(use.backspace)
                .should('have.value', '--:30 PM')
                .then(a11yHasExpectedHtml("<p>blank.</p>"))
                .then(hasReturnVal(''));
        });
    });
}
exports.deleteHours = deleteHours;
